export default __webpack_public_path__ + "static/media/dino_showroom_230vth_kori.2884cb70.jpg";